import Vue from 'vue'
import Router from 'vue-router'
import Step1 from './views/step1/index.vue'
import Step2 from './views/step2/index.vue'
import Step3 from './views/step3/index.vue'
import H5Index from './views/h5/index/index.vue';
import H5Pc from './views/h5/pc/index.vue';
import H5List from './views/h5/list/index.vue';
import H5Share from './views/h5/share/index.vue';
import H5PartnerShare from './views/h5/partnerShare/index.vue';
import H5Follow from './views/h5/follow/index.vue';
import H5Content from './views/h5/content/index.vue';
import H5Distribution from './views/h5/distribution/index.vue';
import DushuIndex from './views/dushu/index/index.vue';
import DushuAdmin from './views/dushu/admin/index.vue';
import ProfilesRest from './engine/Profiles';
import { utils } from './util/index';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'step1',
      component: Step1
    },
    {
      path: '/step2',
      name: 'step2',
      component: Step2
    },
    {
      path: '/step3',
      name: 'step3',
      component: Step3
    },
    {
      path: '/h5',
      name: 'h5Index',
      component: H5Index,
    },
    {
      path: '/h5/pc',
      name: 'h5Pc',
      component: H5Pc,
    },
    {
      path: '/h5/list',
      name: 'h5List',
      component: H5List,
    },
    {
      path: '/h5/share',
      name: 'h5Share',
      component: H5Share,
    },
    {
      path: '/h5/follow',
      name: 'h5Follow',
      component: H5Follow,
    },
    {
      path: '/h5/partner-share',
      name: 'h5PartnerShare',
      component: H5PartnerShare,
    },
    {
      path: '/h5/content',
      name: 'h5Content',
      component: H5Content,
    },
    {
      path: '/h5/distribution',
      name: 'h5Distribution',
      component: H5Distribution,
    },
    {
      path: '/dushu/',
      name: 'dushuIndex',
      component: DushuIndex,
    },
    {
      path: '/dushu-admin/',
      name: 'dushuAdmin',
      component: DushuAdmin,
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'h5Follow') {
    next();
    return;
  }
  setTimeout(() => {
    const { qr } = utils.formatQuery(to.query);
    ProfilesRest.partnerLogin(to.name === 'dushuAdmin').then(() => {
      next();
    }, () => {
      const qrQuery = qr ? `?qr=${qr}` : '';
      next({ path: `/h5/follow/${qrQuery}`, replace: true });
    });
  }, 0);
});

export default router;
